<article class="">
    <header class="">
        <div class="">
            <ul class="list-inline d-flex justify-content-between mb-0">
                <li class="list-inline-item">
                    <h1 class="">Container Types</h1>
                </li>
                <li class="list-inline-item">
                    <button class="btn btn-icon btn-light-info mx-1"(click)="printPage()">
                        <i class="ti ti-printer"></i>
                    </button>
                    <button aria-label="Copy link" class="btn btn-icon btn-light-info"(click)="copyFullPageText()">
                        <i class="ti ti-copy"></i>
                    </button>
                </li>
            </ul>
        </div>
    </header>
    <div class=""> 
        <div class="card-body p-2" data-testid="article-body" dir="auto">
            <p class="mt-1">Xeneta provides coverage for the following types of cargo containers:</p>
            <ul>
                <li class="my-4"><strong>20' DC</strong> — Standard 20 foot dry cargo</li>
                <li class="my-4"><strong>20' RE/RF</strong> — 20 foot reefer</li>
                <li class="my-4"><strong>20' TK</strong> — 20 foot tank</li>
                <li class="my-4"><strong>40' DC&nbsp;</strong>— Standard 40 foot dry cargo</li>
                <li class="my-4"><strong>40' HC</strong> — Standard 40 foot high cube</li>
                <li class="my-4"><strong>40' RH</strong> — 40 foot reefer high cube</li>
            </ul>
            <blockquote class="my-4 p-3 bg-gray-200 color-block">
                <p>Note that some container types, such as <strong>20' Reefer</strong>, <strong>40' Reefer HC</strong>,
                    and <strong>20' Tank</strong>, may have fewer available rates due to generally lower volume of cargo
                    transported using these containers compared to more common container types.</p>
            </blockquote>
        </div>
    </div>
</article>